import { sanitizeUrl } from '@braintree/sanitize-url'

let pendingRedirectHandler: ((e: Event) => void) | null = null

export const redirectAfterResultScreen = (url: string): void => {
  if (pendingRedirectHandler) {
    document.removeEventListener('click', pendingRedirectHandler)
  }
  const handleClick = (e: Event) => {
    if ((e.target as Element)?.closest('.yuno-status__button')) {
      document.removeEventListener('click', handleClick)
      pendingRedirectHandler = null
      redirectTo(url)
    }
  }
  pendingRedirectHandler = handleClick
  document.addEventListener('click', handleClick)
}

export const redirectTo = (url: string) => {
    const urlSanitized = sanitizeUrl(url)

    if (urlSanitized === 'about:blank') {
        console.error('Invalid URL ' + url)
    } else {
        window.location.href = urlSanitized
    }

}

export const buildCallbackUrl = (baseUrl: string, status: string, paymentId: string | null): string => {
    const [urlWithoutFragment, ...fragmentParts] = baseUrl.split('#')
    const fragment = fragmentParts.length ? `#${fragmentParts.join('#')}` : ''
    const separator = urlWithoutFragment.includes('?') ? '&' : '?'
    const paymentIdParam = paymentId ? `&payment_id=${paymentId}` : ''
    return `${urlWithoutFragment}${separator}status=${status}${paymentIdParam}${fragment}`
}
